import React from 'react'
import Img from 'gatsby-image'
import styled from 'styled-components'
import { FullAbsolute } from '../styles/Utils'
import media from 'css-in-js-media'

import ArrowDownIcon from '../svg/arrow-down.svg'
import { Variables } from '../styles/Variables'

const HeroBlockSlide_Wrapper = styled.div`
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    transform: translate3d(0, 0, 0px);

    ${media('<desktop')} {
        align-items: flex-start;
        box-sizing: border-box;
    }
`

const SlideSubtitleWrap = styled.div`
    position: absolute;
    bottom: 30px;
    left: 20px;
    z-index: 15;
    color: ${Variables.color.white};
    font-weight: 300;
    font-size: 24px;
    line-height: 30px;
    white-space: pre-wrap;

    ${media('>=desktop')} {
        width: 655px;
        left: 80px;
        bottom: 40px;
    }
`

const Subtitle = styled.div`
    font-family: ${Variables.font.title};
    font-style: normal;
    font-weight: 300;
    font-size: 38px;
    line-height: 44px;
    color: ${Variables.color.white};
    margin-bottom: 20px;

    ${media('<desktop')} {
        font-size: 24px;
        line-height: 30px;
    }
`

const ScrollIndicator = styled.div`
    font-size: 14px;
    line-height: 120%;
    letter-spacing: 0.0025em;

    svg path {
        stroke: ${(props) => (props.$invertColor ? Variables.color.pazola : Variables.color.white)};
    }
`

const BackgroundImage = styled.div`
    ${FullAbsolute}

    img {
        object-fit: cover;
        width: 100%;
        height: 100%;
    }
    .gatsby-image-wrapper {
        height: 100%;
    }
`

const DesktopImage = styled.div`
    height: 100%;
    ${media('<desktop')} {
        display: none;
    }
`

const MobileImage = styled.div`
    height: 100%;
    ${media('>=desktop')} {
        display: none;
    }
`

export const WrapSubtitle = styled.div`
    width: 100%;
    height: 316px;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 1;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.5) 42.19%, rgba(0, 0, 0, 0) 100%);
    ${media('<desktop')} {
        height: 147px;
    }
`

const HeroBlockSlide = ({ data }: { data: any }) => {
    const { invertColor } = data
    return (
        <>
            {data && (
                <HeroBlockSlide_Wrapper>
                    <WrapSubtitle>
                        <SlideSubtitleWrap>
                            {data.title && <Subtitle dangerouslySetInnerHTML={{ __html: data.title.title }} />}
                            <ScrollIndicator $invertColor={invertColor}>
                                <ArrowDownIcon />
                            </ScrollIndicator>
                        </SlideSubtitleWrap>
                    </WrapSubtitle>
                    <BackgroundImage>
                        <DesktopImage>
                            <Img fluid={data.desktopImage.fluid} />
                        </DesktopImage>
                        <MobileImage>
                            <Img fluid={data.mobileImage.fluid} />
                        </MobileImage>
                    </BackgroundImage>
                </HeroBlockSlide_Wrapper>
            )}
        </>
    )
}

export default HeroBlockSlide
